import $ from 'jquery';

export default class HomeHero {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.scroll();
  }

  scroll() {
    $(window).scroll(() => {
      this.$element.find('.scroll').css('opacity', 0.7 - $(window).scrollTop() / 250);
    });
  }
}
